/**
 * 项目管理 (index/ProjectLayout) 引导步骤
 *
 * ProjectLayout 布局结构：
 *   .pl-logo     — Logo 区域
 *   .pl-nav      — 导航菜单容器
 *   .pl-user     — 底部用户信息
 *   .pl-header   — 顶部标题栏
 *   .pl-content  — 主内容区
 */
export default [
    // 第1步：欢迎
    {
        element: '.pl-logo',
        popover: {
            title: '欢迎使用项目管理系统',
            description: '这是项目管理平台，您可以在这里管理项目、配置检查任务和查看执行数据。',
            side: 'right'
        }
    },
    // 第2步：导航菜单
    {
        element: '.pl-nav',
        popover: {
            title: '功能菜单',
            description: '左侧菜单包含您有权限的功能模块：\n• 项目：查看和管理所有项目\n• 回收站：恢复已删除的项目\n• 设置：修改账号密码和页面主题\n\n菜单内容根据您的角色和权限动态显示。',
            side: 'right',
            align: 'start'
        }
    },
    // 第3步：顶部操作栏
    {
        element: '.pl-header',
        popover: {
            title: '顶部操作栏',
            description: '显示当前页面标题，以及搜索、新建项目等操作按钮。\n\n点击"管理后台"可进入系统管理界面。',
            side: 'bottom'
        }
    },
    // 第4步：内容区域
    {
        element: '.pl-content',
        popover: {
            title: '内容区域',
            description: '这里展示项目列表和详情。\n\n点击项目卡片进入项目详情，查看问卷、波次、数据等。',
            side: 'top',
            align: 'start'
        }
    },
    // 第5步：用户信息
    {
        element: '.pl-user',
        popover: {
            title: '个人设置',
            description: '点击用户名可修改密码或退出登录。',
            side: 'right',
            align: 'end'
        }
    }
]
